/* BD-PROMO-0912 — copy chips, client-side expiry, cart discount code via /cart/update.js.
   All handlers are delegated on document so Prestige's section re-renders (cart page + drawer) never orphan them. */
(function () {
  'use strict';
  var now = function () { return Math.floor(Date.now() / 1000); };
  var lastMsg = null, lastMsgAt = 0;

  function copyText(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
    return new Promise(function (res, rej) {
      var ta = document.createElement('textarea'); ta.value = t; ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;opacity:0'; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? res() : rej(); } catch (e) { rej(e); } document.body.removeChild(ta);
    });
  }

  /* expiry: hide any promo element whose data-bd-ends epoch has passed (handles cached pages) */
  function expire() {
    document.querySelectorAll('[data-bd-ends]').forEach(function (el) {
      var ends = parseInt(el.getAttribute('data-bd-ends'), 10);
      if (ends && now() >= ends) el.hidden = true;
    });
  }

  /* ---- copy chips ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bd-copy]'); if (!btn) return;
    var host = btn.closest('[data-bd-code]'); var code = host ? host.getAttribute('data-bd-code') : btn.textContent.trim();
    var live = host ? host.querySelector('[data-bd-live]') : null;
    var txt = btn.querySelector('[data-bd-code-text]');
    copyText(code).then(function () {
      btn.classList.add('is-copied'); if (txt) { txt.setAttribute('data-orig', txt.textContent); txt.textContent = 'Copied'; }
      if (live) live.textContent = 'Code ' + code + ' copied';
      setTimeout(function () { btn.classList.remove('is-copied'); if (txt) txt.textContent = txt.getAttribute('data-orig') || code; }, 1600);
    }).catch(function () { if (live) live.textContent = 'Copy failed. The code is ' + code; });
  });

  /* ---- cart discount code ---- */
  function cartUpdate(discount) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: discount }) })
      .then(function (r) { return r.json(); });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function paintAll(cart) {
    var ok = ((cart && cart.discount_codes) || []).filter(function (c) { return c.applicable; });
    document.querySelectorAll('[data-bd-cart-code]').forEach(function (box) {
      var applied = box.querySelector('[data-bd-applied]'), code = box.querySelector('[data-bd-applied-code]'), input = box.querySelector('input'), msg = box.querySelector('[data-bd-msg]');
      if (ok.length) { applied.classList.add('is-on'); code.textContent = ok.map(function (c) { return c.code; }).join(', '); if (input) input.value = ''; }
      else applied.classList.remove('is-on');
      if (msg && lastMsg && Date.now() - lastMsgAt < 8000) { msg.className = 'BDCartCode__Msg is-' + lastMsg[0]; msg.textContent = lastMsg[1]; }
    });
    return ok;
  }
  function say(box, kind, text) {
    var msg = box.querySelector('[data-bd-msg]'); if (!msg) return;
    msg.className = 'BDCartCode__Msg' + (kind ? ' is-' + kind : ''); msg.textContent = text || '';
    lastMsg = kind ? [kind, text] : null; lastMsgAt = Date.now();
  }
  function setBusy(box, on) { var b = box.querySelector('[data-bd-apply]'); if (b) b.disabled = !!on; }
  function refreshTheme(cart) {
    document.querySelectorAll('.Cart__Total span, .Cart__Checkout > span:last-child').forEach(function (el) {
      if (cart.total_price != null && /\$|\d/.test(el.textContent)) el.textContent = money(cart.total_price);
    });
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    setTimeout(function () { paintAll(cart); }, 500); setTimeout(function () { paintAll(cart); }, 1500);
  }
  function apply(box, discount) {
    setBusy(box, true); say(box, '', '');
    cartUpdate(discount).then(function (cart) {
      var hit = !!discount && (cart.discount_codes || []).some(function (c) { return c.code.toUpperCase() === discount.toUpperCase() && c.applicable; });
      if (discount && !hit) {
        return cartUpdate('').then(function (c2) { setBusy(box, false); paintAll(c2); say(box, 'err', "That code isn't valid for the items in your cart."); });
      }
      setBusy(box, false); paintAll(cart);
      say(box, 'ok', discount ? 'Discount applied. It carries through to checkout.' : 'Discount removed.');
      refreshTheme(cart);
    }).catch(function () { setBusy(box, false); say(box, 'err', 'Could not apply the code. Try again.'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    var ap = t.closest('[data-bd-apply]');
    if (ap) { var box = ap.closest('[data-bd-cart-code]'), input = box.querySelector('input'); var v = (input.value || '').trim(); if (!v) { input.focus(); return; } apply(box, v.toUpperCase()); return; }
    var rm = t.closest('[data-bd-remove]');
    if (rm) { apply(rm.closest('[data-bd-cart-code]'), ''); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-bd-cart-code] input')) {
      e.preventDefault(); var b = e.target.closest('[data-bd-cart-code]').querySelector('[data-bd-apply]'); if (b) b.click();
    }
  });

  /* initial + post-render state */
  function syncState() {
    if (!document.querySelector('[data-bd-cart-code]')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(paintAll).catch(function () {});
  }
  /* "$X with code" line follows the selected variant (Prestige emits variant:changed with detail.variant) */
  function withPrice(variant) {
    var line = document.querySelector('[data-bd-with]'); if (!line || !variant || variant.price == null) return;
    var pct = parseFloat(line.getAttribute('data-bd-pct')) || 0;
    line.querySelector('[data-bd-with-price]').textContent = money(Math.round(variant.price * (1 - pct / 100)));
    var promo = document.querySelector('[data-bd-promo]'); line.hidden = !!(promo && promo.hidden);
  }
  document.documentElement.addEventListener('variant:changed', function (e) { withPrice(e.detail && e.detail.variant); });
  function boot() { expire(); syncState(); var promo = document.querySelector('[data-bd-promo]'); var line = document.querySelector('[data-bd-with]'); if (line && promo && promo.hidden) line.hidden = true; }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.documentElement.addEventListener('cart:updated', function () { setTimeout(syncState, 300); });
  ['sidebar-cart', 'shopify-section-cart-template'].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) new MutationObserver(function () { clearTimeout(el._bdT); el._bdT = setTimeout(syncState, 150); }).observe(el, { childList: true });
  });
  document.addEventListener('shopify:section:load', boot);
  setInterval(expire, 30000);
})();
